import React, { useEffect, useState } from 'react';
import { getData, getImage } from '../../helpers/indexedDbHelper';
import { Link } from 'react-router-dom';
import { useRefresh } from '../../hooks/useRefresh';
import LayoutContent from '../../components/layouts/content2';
import { useTranslation } from 'react-i18next';
import translate from '../../helpers/translate';
import ListProducts from './ListProducts';

function Index() {

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const {change, getInitData} = useRefresh();
    const [menus, setMenus] = useState([]);

    const [showListProduct, setShowListProduct] = useState(false);
    const [dishs, setdishs] = useState(false);

    const [dataPollo, setDataPollo] = useState(false);
    const [dataDrink, setDataDrink] = useState(false);
    const [dataDish, setDataDish] = useState(false);
    
    useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
           
            setMenus(data);
        });
    }, [change]);


    useEffect(() => {
        menus.map((item) => {
        if (item.id === 828) {
            setDataPollo(item);
        }
        if (item.id === 833) {
            setDataDrink(item);
        }

        if (item.id === 831) {
            setDataDish(item);
        }
        });
    }, [menus]);
    


        useEffect(() => {
        const handleVisibilityChange = () => {
        if (document.visibilityState === "hidden") {
            console.log("La página ha perdido el foco (está oculta).");
           setShowListProduct(false)
            getInitData()

        } else if (document.visibilityState === "visible") {
            console.log("La página está en foco (visible).");
        }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        // Limpieza del evento al desmontar el componente
        return () => {
        document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);




      window.onerror = function () {
        console.log('Error global detectado, recargando...');
        setTimeout(() => {
            window.location.reload();
        }, 2000);
      };
    
    
    
    const fetchImage = async (id) => {
        const imageBlob = await getImage(id);
        if (imageBlob) {
            const imageURL = URL.createObjectURL(imageBlob.blob);
            console.log('URL de la imagen:', imageURL);
            return imageURL;
        }
        return null;
    };

    const Categorie =({ data }) => {
        const [image, setImage] = useState(false);
        useEffect(() => {
            fetchImage(`menu-image-${data.id}`).then((url) => {
                if (url) {
                    setImage(url);
                }
            });
        }, []);
        
        return (

            <div  style={
                {
                    width: '100%',
                    height: 56,
                    borderRadius: 5,
                    marginBottom: 10,
                    borderColor: '#efa740',
                    borderWidth: 2,
                    borderStyle: 'solid'
                }
            }>
                 <div onClick={()=>[setShowListProduct(true), setdishs(data)]} style={{textDecoration: 'none',  height: 50,}}>
                    <div style={{
                    height: 50,
                    display: 'flex',
                    flex: 1,
                    backgroundColor: '#fff',
                    justifyContent: 'center',
                    alignItems: 'center',
                        borderColor: '#b8272e',
                     borderStyle: 'solid',
                    borderWidth: 3,
                    position: 'relative',
                }}>
                    <p style={{
                        fontFamily: "LondrinaSolidRegular",
                        textAlign: 'center',
                        alignSelf: 'center',
                        textTransform: 'uppercase',
                            fontSize: data.id === 38 ? 18 : 21,
                        lineHeight: 1,
                        margin: 0,
                        color: 'black',
                       
                    }}>{langEng ? data.name : translate(i18n.language, data.language, data.name)}</p>
                    <img
                        style={{
                            width: '100%',
                            height: 10,
                            position: 'absolute',
                            bottom: 0,
                            left: 0
                        }}
                        src={require('./assets/App_new-24.jpg')}
                    />
                </div>
            </div>
                    
            </div>

           
        );
    }

    return (
        <LayoutContent showBack={false}>
            <div>
                <div onClick={()=>[setShowListProduct(true), setdishs(dataPollo)]}  style={{ marginTop: -2}}>
                    <video src={require('./assets/pollo.mp4')} loop autoPlay={true} muted style={{
                        width: '100%',
                        height: 200,
                        borderRadius: 14,
                        objectFit: "cover",
                       
                    }}/>
                </div>
               
                <div style={{display: 'flex', width: '100%', marginTop: 20}}>
                    <div style={{ width: '75%' }}>
                        <div style={{display: 'flex', width: '100%', justifyContent: 'space-between'}}>
                            <div onClick={()=>[setShowListProduct(true), setdishs(dataDrink)]} style={{width: '49%'}}>
                                <video src={require('./assets/Chichanueva.mp4')} loop autoPlay={true} muted style={{
                                    width: '100%',
                                    height: 330,
                                    borderRadius: 20,
                                    objectFit: "cover"
                                }}/>
                            </div>
                            <div style={{ width: '49%' }}>
                               <img
                                    style={{
                                        width: '100%',
                                        height: 330,
                                        objectFit: 'cover',
                                        borderRadius: 20
                                    }}
                                    src={require('./assets/App_new-22.png')}
                                />
                             </div>
                        </div>


                        <div onClick={() => {
                            //[setShowListProduct(true), setdishs(dataDish)]
                        }}
                            style={{width: '100%',  borderRadius: 20, }}
                        >
                            <video
                                loop
                                autoPlay
                                muted
                            style={{
                                width: '100%',
                                height: 260,
                                objectFit: 'cover',
                                    borderRadius: 20,
                                marginTop: 10
                            }}
                            src={require('./assets/bannerhome.mp4')}
                            />
                            
                        </div>
                        

                    </div>
                    <div style={{ width: '25%', paddingLeft: 12 }}>
                        
                          <div
                            style={{
                                display: "flex",
                                flexDirection: 'row',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                width: '100%',
                                marginBottom: 10
                            }}>
                            <img
                                style={{
                                    width: '30%',
                                    height: 20,
                                    objectFit: 'cover'
                                }}
                                src={require('./assets/brand.png')}
                            />
                            <p
                                style={ {fontFamily: "LondrinaSolidRegular", textTransform: 'uppercase',fontSize: 30, color: 'white', margin: 0, }}>
                                Menú
                            </p>
                            <img
                                style={{
                                    width: '30%',
                                    height: 20,
                                    objectFit: 'cover'
                                }}
                                src={require('./assets/brand.png')}
                            />
                        </div>
                        

                        {menus.map((item, key) => (
                            <Categorie data={ item}  key={key} />
                        ))}
                    </div>
                </div>
               
            </div>

            {showListProduct && <ListProducts
                dishs={dishs}
                setShowListProduct={setShowListProduct}
            />}
        </LayoutContent>
    );
}

export default Index;